
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.801 0h3.066l-6.731 8.487L20 20h-6.171l-4.832-6.996L3.466 20H.4l7.13-9.077L0 0h6.325l4.365 6.391L15.8 0zm-1.073 18.007h1.7L5.432 1.92H3.605l11.123 16.088z","fill-rule":"nonzero","fill":"inherit"}})])
      }
    
      }
    